import cx from 'classnames2';
import React from 'react';
import { useListTableVariantContext } from '../ListTable';
import styles from './ListTable.Cell.scss';
export var ListTableCell = function ListTableCell(_ref) {
  var dataTest = _ref.dataTest,
      children = _ref.children;
  var variant = useListTableVariantContext();
  return React.createElement("div", {
    className: cx(styles.cell, variant === 'condensed' && styles.variantCondensed),
    "data-test": dataTest
  }, children);
};